import styled from 'styled-components';

export const Hexagon = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;

export const Check = styled.path`
  color: ${({ theme }) => theme.colors.white};
`;
